// extracted by mini-css-extract-plugin
export default {"identity-summary":"sRTKGirvtuQc55PArRpp","name-and-version":"kvvU5k44EXsCYNw8bmfC","version":"URdu6JVkepy8MU5posQv"};